import { getterTypes, mutationTypes, actionTypes } from 'BASE/store/types';
import { storage } from 'BASE/common/util/util.storage';
import moment from 'moment';

function state() {
    return {
        isLogin: false,
        isAgent: false,
        userName: '',
        nickName: '',
        headImage: '',
        walletAmount: 0,
        effectiveTime: 10, //單位分鐘
        privileges: {
            isTransferPointEnabled: undefined,
            isSuperTransferPointEnabled: undefined,
            contractCreationAllowed: undefined,
            dailyPayCreationAllowed: undefined,
            haveContract: undefined,
            haveExternalGameContract: undefined,
            haveSportContract: undefined,
            haveDailyPay: undefined,
            haveCGDailyPay: undefined,
            haveExternalGameDailyPay: undefined,
            haveSportGameDailyPay: undefined,
            dailyPayPermission: [],
            haveBonusWallet: undefined,
            isDepositFromWalletEnabled: undefined,
        },
        registerLinkCode: '',
        merchantCode: '',
        loginType: 0,
        hideWalletAmount: false, //是否顯示餘額
        audioMuted: false, //音效是否靜音
        hideAwardNotify: false, //是否隱藏中獎通知
        showAnimalNumber: true, //是否顯示動物號

        DemoLink: '', //試玩
        unreadAnnouncement: 0,
        unreadActivityCount: 0, //活動未讀數
        agentActivityNotice: {
            teamActivityUnreadCount: 0, //團隊活動未讀
            teamRedPackRainCount: 0, //團隊紅包雨未讀
        },
        hasChatExternalLink: undefined, //是否有外接客服
        hasChatSiteGroup: undefined, //是否有全站群聊
        SecurityScore: 0,
        IsDemoSite: false, //Demo
        skinClass: '',
        isWeChatEnabled: false,
        show_download_shortcut: undefined, //首頁顯示下載APP入口
        speedTestConfig: {
            URLList: [], //商務後台設置的網址
            IntervalInMinute: 0, //自動換URL，預設為0，表示不換
        },
        IsEnableCheckIP: false,
        IsEnableGoogleAuthenticator: false,
        Email: '',
        haveAuthQuestion: false,
        afkUrlSet: {},
        playerBaseData: undefined, //玩家基本資料
        Announcements: [],
        selected_announcement_ID: -1,
        IsLoginWithGoogleAuth: false,
        alerts: {
            isChatEnabled: undefined,
            isFengDanEnabled: undefined,
            isDrawEnabled: undefined,
            isWinningEnabled: undefined,
        },
        vipinfo: {
            //vip資料
            Level: 0,
        },
        afkConfig: {
            AFKAndroidFile:'',
            AFKAndroidUrl:'',
            AFKPcFile:'',
            AFKPcUrl:'',
            AFKZCBPcFile:'',
            AFKZCBPcUrl:'',
            AFKiosUrl:'',
            AndroidAPPFile:'',
            AndroidAPPUrl:'',
            CodePushCheckEnable: false,
            CordovaAppVersion: '',
            IOSPlistPath: '',
            LegendAFKAndroidFile: '',
            LegendAFKAndroidUrl: '',
            LegendAFKPCFile: '',
            LegendAFKPCUrl: '',
            LegendAFKTelegramGuideUrl: '',
            LegendAFKVpnGuideUrl: '',
            LegendAFKiosUrl: '',
            LoginUrl: '',
            SmartAFKUrl: '',
        },
        activityInfo: {
            redPacketSolitaireEntryable: undefined,
        },
        greetings: '',
        initialized: false,
        openDragableComboBet: false
    };
}

const getters = {
    //有需state做運算在使用該方式
};

const mutations = {
    [mutationTypes.USER_INFO_INIT](state, payload) {
        state.isLogin = payload.isLogin;
        state.isAgent = payload.isAgent;
        state.userName = payload.userName;
        state.nickName = payload.nickName;
        state.loginType = payload.loginType;
        state.greetings = payload.greetings;
        state.showAnimalNumber = payload.showAnimalNumber;
    },
    [mutationTypes.USER_INFO_NICK_NAME](state, payload) {
        state.nickName = payload.nickName;
    },
    [mutationTypes.USER_INFO_HEAD_IMAGE](state, payload) {
        state.headImage = payload.headImage;
    },
    [mutationTypes.USER_INFO_REGISTER_LINK_CODE](state, payload) {
        state.registerLinkCode = payload.registerLinkCode;
    },
    [mutationTypes.USER_INFO_IS_WECHAT_ENABLED](state, payload) {
        state.isWeChatEnabled = payload.isWeChatEnabled;
    },
    [mutationTypes.USER_INFO_PRIVILEGES](state, payload) {
        state.privileges.isTransferPointEnabled = payload.isTransferPointEnabled;
        state.privileges.isSuperTransferPointEnabled = payload.isSuperTransferPointEnabled;
        state.privileges.isDepositFromWalletEnabled = payload.isDepositFromWalletEnabled;
    },
    [mutationTypes.USER_INFO_PRIVILEGES_BONUS](state, payload) {
        state.privileges.contractCreationAllowed = payload.contractCreationAllowed;
        state.privileges.dailyPayCreationAllowed = payload.dailyPayCreationAllowed;
        state.privileges.haveContract = payload.haveContract;
        state.privileges.haveExternalGameContract = payload.haveExternalGameContract;
        state.privileges.haveSportContract = payload.haveSportContract;
        state.privileges.haveDailyPay = payload.haveDailyPay;
        state.privileges.haveCGDailyPay = payload.haveCGDailyPay;
        state.privileges.haveExternalGameDailyPay = payload.haveExternalGameDailyPay;
        state.privileges.haveSportGameDailyPay = payload.haveSportGameDailyPay;
        state.privileges.dailyPayPermission = payload.dailyPayPermission;
        state.privileges.haveBonusWallet = payload.haveBonusWallet;
    },
    [mutationTypes.USER_INFO_WALLET_AMOUNT](state, payload) {
        state.walletAmount = payload.walletAmount;
    },
    [mutationTypes.USER_INFO_MERCHANT_CODE](state, payload) {
        state.merchantCode = payload.merchantCode;
    },
    [mutationTypes.USER_INFO_HIDE_WALLET_AMOUNT](state, payload) {
        state.hideWalletAmount = payload.hideWalletAmount;
    },
    [mutationTypes.USER_INFO_AUDIO_MUTED](state, payload) {
        state.audioMuted = payload.audioMuted;
    },
    [mutationTypes.USER_INFO_HIDE_AWARD_NOTIFY](state, payload) {
        state.hideAwardNotify = payload.hideAwardNotify;
    },
    [mutationTypes.USER_INFO_SHOW_ANIMAL_NUMBER](state, payload) {
        state.showAnimalNumber = payload.showAnimalNumber;
        let animalOlympic = storage.local.get(storage.keys.BET_ANIMAL_OLYMPIC);
        storage.local.set(storage.keys.BET_ANIMAL_OLYMPIC, { ...animalOlympic, showAnimalNumber: payload.showAnimalNumber });

    },
    [mutationTypes.USER_INFO_DEMO_LINK](state, payload) {
        state.DemoLink = payload.DemoLink;
    },
    [mutationTypes.AFK_CONFIG](state, payload) {
        state.afkConfig = payload.afkConfig;
    },
    [mutationTypes.UNREAD_ANNOUNCEMENT](state, payload) {
        state.unreadAnnouncement = payload.unreadAnnouncement;
    },
    [mutationTypes.UNREAD_ACTIVITY_COUNT](state, payload) {
        state.unreadActivityCount = payload.unreadActivityCount;
    },
    [mutationTypes.AGENTACTIVITY_NOTICE_TEAMACTIVITY_UNREAD_COUNT](state, payload) {
        state.agentActivityNotice.teamActivityUnreadCount = payload.teamActivityUnreadCount;
    },
    [mutationTypes.AGENTACTIVITY_NOTICE_TEAMREDPACKRAIN_COUNT](state, payload) {
        state.agentActivityNotice.teamRedPackRainCount = payload.teamRedPackRainCount;
    },
    [mutationTypes.SECURITY_SCORE](state, payload) {
        state.SecurityScore = payload.SecurityScore;
    },
    [mutationTypes.USER_INFO_DEMO_SITE](state, payload) {
        state.IsDemoSite = payload.IsDemoSite;
    },
    [mutationTypes.USER_INFO_SKIN_COLOR](state, payload) {
        state.skinClass = payload.skinClass;
    },
    [mutationTypes.DOWNLOAD_SHORTCUT](state, payload) {
        state.show_download_shortcut = payload.show_download_shortcut;
    },
    [mutationTypes.SPEED_TEST_URL_LIST](state, payload) {
        state.speedTestConfig.URLList = payload.urlList;
    },
    [mutationTypes.SPEED_TEST_CONFIG](state, payload) {
        state.speedTestConfig.IntervalInMinute = payload.speedTestConfig.SpeedTestIntervalInMinute;
        state.speedTestConfig.EnableSwitchURL = payload.speedTestConfig.EnableSwitchURL;
    },
    [mutationTypes.IS_ENABLE_CHECKIP](state, payload) {
        state.IsEnableCheckIP = payload.IsEnableCheckIP;
    },
    [mutationTypes.IS_ENABLE_GOOGLEAUTHENTICATOR](state, payload) {
        state.IsEnableGoogleAuthenticator = payload.IsEnableGoogleAuthenticator;
    },
    [mutationTypes.EMAIL](state, payload) {
        state.Email = payload.Email;
    },
    [mutationTypes.HAVE_AUTH_QUESTION](state, payload) {
        state.haveAuthQuestion = payload.haveAuthQuestion;
    },
    [mutationTypes.AFK_URL_SET](state, payload) {
        state.afkUrlSet = payload.afkUrlSet;
    },
    [mutationTypes.USER_INFO_GET_BASE_DATA](state, payload) {
        state.playerBaseData = payload.playerBaseData;
    },
    [mutationTypes.ANNOUNCEMENTS](state, payload) {
        state.Announcements = payload.Announcements;
    },
    [mutationTypes.SELECTED_ANNOUNCEMENT_ID](state, payload) {
        state.selected_announcement_ID = payload.selected_announcement_ID;
    },
    [mutationTypes.IS_LOGIN_WITH_GOOGLEAUTH](state, payload) {
        state.IsLoginWithGoogleAuth = payload.IsLoginWithGoogleAuth;
    },
    [mutationTypes.CHAT_INFO](state, payload) {
        state.hasChatExternalLink = payload.hasChatExternalLink;
        state.hasChatSiteGroup = payload.hasChatSiteGroup;
    },
    [mutationTypes.USER_INFO_ALERTS](state, payload) {
        if (payload.isChatEnabled != undefined) state.alerts.isChatEnabled = payload.isChatEnabled;

        if (payload.isFengDanEnabled != undefined) state.alerts.isFengDanEnabled = payload.isFengDanEnabled;

        if (payload.isDrawEnabled != undefined) state.alerts.isDrawEnabled = payload.isDrawEnabled;

        if (payload.isWinningEnabled != undefined) state.alerts.isWinningEnabled = payload.isWinningEnabled;
    },
    [mutationTypes.VIP_INFO](state, payload) {
        state.vipinfo = payload.vipinfo;
    },
    [mutationTypes.ACTIVITY_INFO](state, payload) {
        if (payload.redPacketSolitaireEntryable != undefined)
            state.activityInfo.redPacketSolitaireEntryable = payload.redPacketSolitaireEntryable;
    },
    [mutationTypes.USER_INFO_GREETINGS](state, payload) {
        state.greetings = payload.greetings;
    },

    [mutationTypes.USER_INFO_INITIALIZED](state, payload) {
        state.initialized = payload.initialized;
    },
    [mutationTypes.TOGGLE_DRAGGABLE_COMBO_BET](state,payload) {
        state.openDragableComboBet = payload;
    },
};

const actions = {
    [actionTypes.USER_INFO_INIT](context, payload) {
        let _info = {
            isLogin: false,
            isAgent: false,
            showAnimalNumber: true,
            userName: '',
            nickName: '',
            greetings: '',
            loginType: 0,
        };

        if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
            _info.isLogin = true;
            _info.isAgent = storage.local.get(storage.keys.ISAGENT);
            _info.userName = storage.local.get(storage.keys.USER_NAME);
            var nickname = storage.local.get(storage.keys.NICK_NAME);
            if (typeof nickname != 'object') {
                _info.nickName = nickname;
            }
            _info.loginType = storage.local.get(storage.keys.LOGIN_TYPE);
            _info.greetings = storage.local.get(storage.keys.GREETINGS);

            let today = moment(new Date()).format('YYYY/MM/DD');
            let displayDate = storage.local.get(storage.keys.BET_AWARD_ENTRY);
            context.commit(mutationTypes.USER_INFO_HIDE_AWARD_NOTIFY, { hideAwardNotify: today == displayDate });
        }

        let animalOlympic = storage.local.get(storage.keys.BET_ANIMAL_OLYMPIC);
        if(animalOlympic) {
            _info.showAnimalNumber = animalOlympic.showAnimalNumber;
        }

        context.commit(mutationTypes.USER_INFO_INIT, _info);
    },
    [actionTypes.USER_INFO_NICK_NAME](context, payload) {
        context.commit(mutationTypes.USER_INFO_NICK_NAME, { nickName: payload.nickName });
    },
    [actionTypes.USER_INFO_HEAD_IMAGE](context, payload) {
        context.commit(mutationTypes.USER_INFO_HEAD_IMAGE, { headImage: payload.headImage });
    },
    [actionTypes.USER_INFO_GREETINGS](context, payload) {
        storage.local.set(storage.keys.GREETINGS, payload.greetings);
        context.commit(mutationTypes.USER_INFO_GREETINGS, { greetings: payload.greetings });
    },
    // 更新後台共用推廣代碼
    async [actionTypes.USER_INFO_REGISTER_LINK_CODE](context, payload) {
        let _tag = storage.keys.REGISTER_LINK_CODE;
        let _regRegisterLinkCode = storage.local.get(_tag);
        if (_regRegisterLinkCode) {
            context.commit(mutationTypes.USER_INFO_REGISTER_LINK_CODE, { registerLinkCode: _regRegisterLinkCode });
        } else {
            try {
                let _result = await $.post('/api/Register/GetRegisterLinkCode');
                if (_result) {
                    let _newExpiresTime = new Date().getTime() + context.state.effectiveTime * 60 * 1000; //10分鐘有效
                    storage.local.set(_tag, _result, _newExpiresTime);
                    context.commit(mutationTypes.USER_INFO_REGISTER_LINK_CODE, { registerLinkCode: _result });
                }
            } catch (error) {
                console.error(error);
            }
        }
    },
    //微信設置是否有開啟
    async [actionTypes.USER_INFO_IS_WECHAT_ENABLED](context, payload) {
        if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
            try {
                let _result = await $.post('/api/Wechat/Enabled');
                context.commit(mutationTypes.USER_INFO_IS_WECHAT_ENABLED, { isWeChatEnabled: _result });
            } catch (error) {
                console.error(error);
            }
        }
    },
    //更新錢包餘額
    async [actionTypes.USER_INFO_WALLET_AMOUNT](context, payload) {
        if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
            try {
                let _result = await $.post('/api/Wallet/GetWalletAmount');
                context.commit(mutationTypes.USER_INFO_WALLET_AMOUNT, { walletAmount: _result });
            } catch (err) {
                console.error(err);
            }
        }
    },
    //一鍵回收
    async [actionTypes.USER_INFO_RECYCLE_ALL](context, payload) {
        if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
            try {
                let _result = await $.postJSON('/api/ExternalGameTrans/Recycle', {});
                context.commit(mutationTypes.USER_INFO_WALLET_AMOUNT, { walletAmount: _result.WalletAmount });
            } catch (err) {
                console.error(err);
            }
        }
    },
    //更新權限(轉點)
    async [actionTypes.USER_INFO_PRIVILEGES](context, payload) {
        context.commit(mutationTypes.USER_INFO_PRIVILEGES, {
            isTransferPointEnabled: undefined,
            isSuperTransferPointEnabled: undefined,
            isDepositFromWalletEnabled: undefined,
        });
        if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
            try {
                let _result = await $.post('/api/Privileges/Get');
                context.commit(mutationTypes.USER_INFO_PRIVILEGES, {
                    isTransferPointEnabled: _result.isTransferPointEnabled,
                    isSuperTransferPointEnabled: _result.isSuperTransferPointEnabled,
                    isDepositFromWalletEnabled: _result.isDepositFromWalletEnabled,
                });
            } catch (err) {
                console.error(err);
            }
        }
    },
    //更新權限(日工資、契約)
    async [actionTypes.USER_INFO_PRIVILEGES_BONUS](context, payload) {
        context.commit(mutationTypes.USER_INFO_PRIVILEGES_BONUS, {
            contractCreationAllowed: undefined,
            dailyPayCreationAllowed: undefined,
            haveContract: undefined,
            haveExternalGameContract: undefined,
            haveSportContract: undefined,
            haveDailyPay: undefined,
            haveCGDailyPay: undefined,
            haveExternalGameDailyPay: undefined,
            haveSportGameDailyPay: undefined,
            dailyPayPermission: [],
            haveBonusWallet: undefined,
        });
        if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
            try {
                let _result = await $.post('/api/BonusPrivileges/Get');
                let dailyPayCreationAllowed = _result.dailyPayPermission.length > 0 ? true : false;
                context.commit(mutationTypes.USER_INFO_PRIVILEGES_BONUS, {
                    contractCreationAllowed: _result.contractCreationAllowed,
                    dailyPayCreationAllowed: dailyPayCreationAllowed,
                    haveContract: _result.haveContract,
                    haveExternalGameContract: _result.haveExternalGameContract,
                    haveSportContract: _result.haveSportContract,
                    haveDailyPay: _result.haveDailyPay,
                    haveSportGameDailyPay: _result.haveSportGameDailyPay,
                    haveCGDailyPay: _result.haveCGDailyPay,
                    haveExternalGameDailyPay: _result.haveExternalGameDailyPay,
                    dailyPayPermission: _result.dailyPayPermission,
                    haveBonusWallet: _result.haveBonusWallet,
                });
            } catch (err) {
                console.error(err);
            }
        }
    },
    //更新商戶代碼
    async [actionTypes.USER_INFO_MERCHANT_CODE](context, payload) {
        let _tag = storage.keys.MERCHANT_CODE;
        let _regMerchantCode = storage.local.get(_tag);
        if (_regMerchantCode) {
            context.commit(mutationTypes.USER_INFO_MERCHANT_CODE, { merchantCode: _regMerchantCode });
        } else {
            try {
                let _result = await $.post('/api/Merchant/GetMerchantCode');
                if (_result) {
                    storage.local.set(_tag, _result);
                    context.commit(mutationTypes.USER_INFO_MERCHANT_CODE, { merchantCode: _result });
                }
            } catch (error) {
                console.error(error);
            }
        }
    },
    //是否有外接客服
    async [actionTypes.CHAT_INFO](context, payload) {
        try {
            let _result = await $.post('/api/Chat/GetChatInfo');
            if (_result) {
                context.commit(mutationTypes.CHAT_INFO, { 
                    hasChatExternalLink: _result.HasChatExternalLink,
                    hasChatSiteGroup: _result.HasChatSiteGroup,
                });
            }
        } catch (error) {
            console.error(error);
        }
    },
    //是否隱藏餘額
    [actionTypes.USER_INFO_HIDE_WALLET_AMOUNT](context, payload) {
        context.commit(mutationTypes.USER_INFO_HIDE_WALLET_AMOUNT, { hideWalletAmount: payload.hideWalletAmount });
    },
    //是否靜音
    [actionTypes.USER_INFO_AUDIO_MUTED](context, payload) {
        context.commit(mutationTypes.USER_INFO_AUDIO_MUTED, { audioMuted: payload.audioMuted });
    },
    //是否隱藏中獎通知
    [actionTypes.USER_INFO_HIDE_AWARD_NOTIFY](context, payload) {
        context.commit(mutationTypes.USER_INFO_HIDE_AWARD_NOTIFY, { hideAwardNotify: payload.hideAwardNotify });
        if (payload.hideAwardNotify) {
            let today = moment(new Date()).format('YYYY/MM/DD');
            storage.local.set(storage.keys.BET_AWARD_ENTRY, today);
        }
    },
    //更新後台試玩連結
    async [actionTypes.USER_INFO_DEMO_LINK](context, payload) {
        let _tag = storage.keys.DEMO_LINK;
        let _DemoLink = storage.local.get(_tag);
        if (_DemoLink) {
            context.commit(mutationTypes.USER_INFO_DEMO_LINK, { DemoLink: _DemoLink });
        } else {
            try {
                let _result = await $.post('/api/Register/GetDemoLink');
                if (_result) {
                    let _newExpiresTime = new Date().getTime() + context.state.effectiveTime * 60 * 1000; //10分鐘有效
                    storage.local.set(_tag, _result, _newExpiresTime);
                    context.commit(mutationTypes.USER_INFO_DEMO_LINK, { DemoLink: _result });
                }
            } catch (error) {
                console.error(error);
            }
        }
    },
    //更新後台掛機設置(下載中心)
    async [actionTypes.AFK_CONFIG](context, payload) {
        let _tag = storage.keys.AFK_CONFIG;
        let _afkConfig = storage.local.get(_tag);
        if (_afkConfig) {
            context.commit(mutationTypes.AFK_CONFIG, { afkConfig: _afkConfig });
        } else {
            try {
                let _result = await $.post('/api/AFK/GetAFKConfig');
                if (_result) {
                    let _newExpiresTime = new Date().getTime() + context.state.effectiveTime * 60 * 1000; //10分鐘有效
                    storage.local.set(_tag, _result, _newExpiresTime);
                    context.commit(mutationTypes.AFK_CONFIG, { afkConfig: _result });
                }
            } catch (error) {
                console.error(error);
            }
        }
    },
    // 更新未讀公告數
    async [actionTypes.UNREAD_ANNOUNCEMENT](context, payload) {
        if (payload) {
            context.commit(mutationTypes.UNREAD_ANNOUNCEMENT, { unreadAnnouncement: payload.unreadAnnouncement });
        } else if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
            try {
                let _result = await $.post('/api/Annoucement/GetUnreadAnnouncementCount');
                context.commit(mutationTypes.UNREAD_ANNOUNCEMENT, { unreadAnnouncement: _result });
            } catch (err) {
                console.error(err);
            }
        }
    },
    // 玩家帳號,創建時間,上一次登入時間
    async [actionTypes.USER_INFO_GET_BASE_DATA](context, payload) {
        if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
            try {
                let _result = await $.post('/api/AccountCenter/GetPlayerBaseData');
                context.commit(mutationTypes.USER_INFO_GET_BASE_DATA, {
                    playerBaseData: _result.playerData,
                });
            } catch (err) {
                console.error(err);
            }
        }
    },
    // 更新未讀活動公告數
    async [actionTypes.UNREAD_ACTIVITY_COUNT](context, payload) {
        context.commit(mutationTypes.UNREAD_ACTIVITY_COUNT, { unreadActivityCount: payload.unreadActivityCount });
    },
    // 更新團隊可領次數
    [actionTypes.AGENTACTIVITY_NOTICE_TEAMACTIVITY_UNREAD_COUNT](context, payload) {
        context.commit(mutationTypes.AGENTACTIVITY_NOTICE_TEAMACTIVITY_UNREAD_COUNT, {
            teamActivityUnreadCount: payload.teamActivityUnreadCount,
        });
    },
    // 更新團隊紅包雨可領次數
    [actionTypes.AGENTACTIVITY_NOTICE_TEAMREDPACKRAIN_COUNT](context, payload) {
        context.commit(mutationTypes.AGENTACTIVITY_NOTICE_TEAMREDPACKRAIN_COUNT, {
            teamRedPackRainCount: payload.teamRedPackRainCount,
        });
    },
    // Security Score
    [actionTypes.SECURITY_SCORE](context, payload) {
        context.commit(mutationTypes.SECURITY_SCORE, { SecurityScore: payload.SecurityScore });
    },
    // 試玩站
    async [actionTypes.USER_INFO_DEMO_SITE](context, payload) {
        context.commit(mutationTypes.USER_INFO_DEMO_SITE, { IsDemoSite: payload.isDemoSite });
    },
    // 換膚
    [actionTypes.USER_INFO_SKIN_COLOR](context, payload) {
        context.commit(mutationTypes.USER_INFO_SKIN_COLOR, { skinClass: payload.skinClass });
    },
    [actionTypes.DOWNLOAD_SHORTCUT](context, payload) {
        context.commit(mutationTypes.DOWNLOAD_SHORTCUT, { show_download_shortcut: payload.show_download_shortcut });
    },
    // 更新speedTestConfig
    async [actionTypes.SPEED_TEST_CONFIG](context, payload) {
        var _expiresTime = new Date().getTime() + 60 * 60 * 1000; //object 格式的必須添加有效時間，除了純字串才可不必加
        storage.session.set(storage.keys.SPEED_TEST_CONFIG, payload, _expiresTime);
        context.commit(mutationTypes.SPEED_TEST_CONFIG, { speedTestConfig: payload });
    },
    // 更新URL List
    async [actionTypes.SPEED_TEST_URL_LIST](context, payload) {
        var _expiresTime = new Date().getTime() + 60 * 60 * 1000; //object 格式的必須添加有效時間，除了純字串才可不必加
        storage.session.set(storage.keys.SPEED_TEST_URL_LIST, payload, _expiresTime);
        context.commit(mutationTypes.SPEED_TEST_URL_LIST, { urlList: payload });
    },
    // 更新IsEnableCheckIP
    [actionTypes.IS_ENABLE_CHECKIP](context, payload) {
        context.commit(mutationTypes.IS_ENABLE_CHECKIP, { IsEnableCheckIP: payload.IsEnableCheckIP });
    },
    // 更新IsEnableGoogleAuthenticator
    [actionTypes.IS_ENABLE_GOOGLEAUTHENTICATOR](context, payload) {
        context.commit(mutationTypes.IS_ENABLE_GOOGLEAUTHENTICATOR, {
            IsEnableGoogleAuthenticator: payload.IsEnableGoogleAuthenticator,
        });
    },
    // 更新Email
    [actionTypes.EMAIL](context, payload) {
        context.commit(mutationTypes.EMAIL, { Email: payload.Email });
    },
    //更新haveAuthQuestion
    [actionTypes.HAVE_AUTH_QUESTION](context, payload) {
        context.commit(mutationTypes.HAVE_AUTH_QUESTION, { haveAuthQuestion: payload.haveAuthQuestion });
    },
    // AFK下載網址有無設定
    [actionTypes.AFK_URL_SET](context, payload) {
        context.commit(mutationTypes.AFK_URL_SET, { afkUrlSet: payload.afkUrlSet });
    },
    // 存入部分公告到store中
    [actionTypes.ANNOUNCEMENTS](context, payload) {
        context.commit(mutationTypes.ANNOUNCEMENTS, { Announcements: payload.Announcements });
    },
    [actionTypes.SELECTED_ANNOUNCEMENT_ID](context, payload) {
        context.commit(mutationTypes.SELECTED_ANNOUNCEMENT_ID, {
            selected_announcement_ID: payload.selected_announcement_ID,
        });
    },
    [actionTypes.IS_LOGIN_WITH_GOOGLEAUTH](context, payload) {
        context.commit(mutationTypes.IS_LOGIN_WITH_GOOGLEAUTH, {
            IsLoginWithGoogleAuth: payload.IsLoginWithGoogleAuth,
        });
    },
    //取得玩家個人中心提示設置
    async [actionTypes.USER_INFO_ALERTS](context, payload) {
        if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
            try {
                let _result = await $.post('/api/AccountCenter/GetAlertInfo');
                context.commit(mutationTypes.USER_INFO_ALERTS, {
                    isFengDanEnabled: _result.IsFengDanEnabled,
                    isDrawEnabled: _result.IsDrawEnabled,
                    isWinningEnabled: _result.IsWinningEnabled,
                    isChatEnabled: _result.IsChatEnabled,
                });
            } catch (err) {
                console.error(err);
            }
        }
    },
    // VIP
    async [actionTypes.VIP_INFO](context, payload) {
        if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
            try {
                let _result = await $.post('/api/VIPnew/GetPlayerVIPInfo');
                context.commit(mutationTypes.VIP_INFO, {
                    vipinfo: _result.vipinfo,
                });
            } catch (err) {
                console.error(err);
            }
        }
    },
};

export default class store {
    constructor() {
        this.state = state();
        this.getters = getters;
        this.actions = actions;
        this.mutations = mutations;
    }
}
